import type { JSX } from 'react';
import type { WireArtifact } from '@logistics/contracts';
import { monthDay, clockTime } from '@/lib/format';

type Email = Extract<WireArtifact, { kind: 'email' }>;

/** The thread, one card per message: sender, time, recipients, subject and the preview. */
export function EmailArtifact({ artifact }: { artifact: Email }): JSX.Element {
  return (
    <div className="flex flex-col gap-2.5">
      {artifact.messages.map((m, i) => (
        <div key={i} className="border-line bg-surf rounded-xl border px-4 py-3.5">
          <div className="flex items-baseline justify-between gap-2.5">
            <span className="min-w-0 truncate text-[13.5px] font-medium">
              {m.from ?? 'Unknown sender'}
            </span>
            <span className="text-mute font-mono text-[10.5px] whitespace-nowrap">
              {monthDay(m.at)}, {clockTime(m.at)}
            </span>
          </div>
          {m.to.length > 0 && (
            <div className="text-mute mt-0.5 truncate text-xs">to {m.to.join(', ')}</div>
          )}
          <div className="mt-2 text-[13px] font-medium [overflow-wrap:anywhere]">{m.subject}</div>
          {m.preview !== undefined && (
            <div className="mt-1.5 text-[13px] leading-[1.55] whitespace-pre-wrap [overflow-wrap:anywhere]">
              {m.preview}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
